var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.active ? "block" : "hidden" }, [
    _c("div", {
      staticClass: "fixed z-50 pin overflow-hidden bg-modal",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4"
      },
      [
        _c("div", { staticClass: "bg-primary rounded shadow" }, [
          _c("div", { staticClass: "p-6" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm.$store.state.formError
              ? _c(
                  "div",
                  { staticClass: "block bg-red rounded text-white mb-6" },
                  [
                    _c("div", { staticClass: "flex items-center" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", [
                        _c("p", {
                          domProps: {
                            textContent: _vm._s(_vm.$store.state.formError)
                          }
                        })
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.terms_accepted,
                    expression: "! terms_accepted"
                  }
                ],
                staticClass: "text-center"
              },
              [
                _c(
                  "label",
                  { staticClass: "block mb-4 text-white text-center" },
                  [
                    _c("span", {
                      staticClass: "text-sm font-semibold ml-1 text-white",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy",
                            {
                              termsUri: _vm.$t("terms_uri"),
                              privacyUri: _vm.$t("privacy_policy_uri")
                            }
                          )
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "flex items-center justify-center rounded bg-blue-dark hover:bg-blue-darker text-white px-4 py-2 w-full",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.acceptTerms()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Continue")) +
                        "\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.terms_accepted,
                    expression: "terms_accepted"
                  }
                ]
              },
              [_c("div", { attrs: { id: "firebaseui-auth-container" } })]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-4" }, [
      _c("img", {
        staticClass: "h-48",
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-alert" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b56a544", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b56a544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/LoginModal.vue
// module id = 577
// module chunks = 1